import Util from '../utils/util.js';
import { webformIsDisabled } from '../utils/webform.js';
import { preserveUnsavedState } from '../utils/beforeunload.js';

if (window.site_type && window.site_type === 'ctr') {

    function setupModule(module_slug, is_subform) {
        if (module_slug == 'researchers' && is_subform) {
            onReadyResearchersSubform();
        }
        if (module_slug == 'publications') { onReadyPublications() }
        if (module_slug === 'ip') { onReadyModuleIP() }
    }

    /**********************************************************
     *                 Researchers module
     */
    function onReadyResearchersSubform() {
        if (webformIsDisabled()) {
            $('#search_researchers').remove();
            return;
        }

        // Handle search
        let id = $('.webform input[name="id"]').val();
        if (id) {
            $('#search-section').removeClass('in');
        } else {
            $('#search-section').addClass('in');
        }

        $('#search_researchers').typeahead({}, {
            name: 'search_researchers',
            displayKey: 'name',
            source: function(query, sync, async) {
                console.log('searching')
                $.ajax(window['public_path'] + '/researchers/search/' + query, {dataType: 'json'})
                 .success(function(result) {
                     async(result);
                 });
            },
            templates: {
                suggestion: function (t) {
                    return '<div><div class="name">'+(t.name||'')+'</div><div class="email">'+(t.email||'')+'</div></div>';
                }
            }
        }).on('typeahead:select typeahead:autocomplete', function($e, datum) {
            Util.setFromJson(datum);
        });
    }

    /**********************************************************
     *                 OnReady handler
     */
    $(document).ready(function() {
        if (typeof window['route_module_slug'] !== 'undefined') {
            let module_slug = window['route_module_slug'];
            let is_subform = module_slug == window['route_subform_element'];

            preserveUnsavedState(() => setupModule(module_slug, is_subform));
        }
    });
}

/**********************************************************
 *                 Publications module
 */
function publicationModifyFields(type)
{
    // Set title (field #2)
    switch (type) {
        case "book":
            $("label[for='title']").text('Book Title');
            break;
        case "book_chapter":
            $("label[for='title']").text('Book Title');
            break;
        default:
            $("label[for='title']").text('Publication Title');
            $('.webform_element_title .help-block').hide();
            break;
    }
}

/**********************************************************
 *                 Publications module
 */
function onReadyPublications() {
    let jType = $('#type');
    jType.change(function() {
        publicationModifyFields(Util.makeBareSlug(jType.val()));
    });
    jType.change();
}

/**********************************************************
 * Intellectual Property Module
 **********************************************************/

function ipModifyFields(type)
{
    // Set title (field #1)
    switch (type) {
        case "patent":
            $("label[for='title']").text('Patent Title');
            break;
        case "invention":
            $("label[for='title']").text('Invention Title');
            break;
        case "license":
            $("label[for='title']").text('License Title');
            break;
        default:
            $("label[for='title']").text('Title');
            break;
    }

    // Set description (field #3)
    switch (type) {
        case "patent":
            $("label[for='description']").text('Patent Abstract');
            break;
        case "invention":
            $("label[for='description']").text('Invention Description');
            break;
        default:
            $("label[for='description']").text('Description');
            break;
    }

    // Set status (field #5)
    switch (type) {
        case "license":
            $("label[for='status']").text('License Status');
            break;
        default:
            $("label[for='status']").text('Status');
            break;
    }
}

function onReadyModuleIP()
{
    let jType = $('#type');
    jType.change(function() {
        ipModifyFields(Util.makeBareSlug(jType.val()));
        Util.setupLabelPositionAdjuster();
    });
    jType.change();
    $('#status').change(function() {
        switch (Util.makeBareSlug($('#status').val())) {
            case 'granted': // granted
                $('.webform').removeClass('not_granted');
                break;
            default:
                $('.webform').addClass('not_granted');
                break;
        }
    }).change();

    $('#invention_disclosure').change(function() {
        switch ($('#invention_disclosure').val()) {
            case "1": // disclosure
                $('.webform').removeClass('not_disclosure');
                break;
            default:
                $('.webform').addClass('not_disclosure');
                break;
        }
    }).change();

    // Assign completion handles to the designated fields.
    Util.assignCompletion(['title'], 'ip')
}
